import React from 'react';
import cssClasses from './PlayerButton.css';
import {FaPlay} from 'react-icons/fa'
import {GiMusicalNotes} from 'react-icons/gi'

class PlayerButton extends React.Component {

    render() {
        const icons = this.props.playing ? <GiMusicalNotes style={{color:"var(--danger)"}}/> : <FaPlay/>;
        return (
            <div
                className={cssClasses.Main}
                onClick={() => {
                    if (!this.props.playing)
                        this.props.onPlayEffect()
                }}
            >
                {icons}
                <p>{this.props.name}</p>
                <audio
                    src={this.props.audioFilePath}
                    ref={this.props.effectRef}
                />
            </div>
        );
    }

}

export default PlayerButton;